import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { conversationSurfaceStore } from '@/store/timeline/conversation-surface-store';
import type { Tweet } from '@/types/tweet/tweet';

export interface TimelineConversationSurfaceValue {
  activeTweet: Tweet | null;
  closeConversation: () => void;
  openConversation: (tweet: Tweet) => void;
  prefetchConversation?: ((tweet: Tweet) => void) | undefined;
}

export function useTimelineConversationSurface(): TimelineConversationSurfaceValue {
  return useStoreWithEqualityFn(
    conversationSurfaceStore,
    (state) => ({
      // Selectors stay narrow so subscribers only re-render when the active tweet
      // or exposed actions change—mirrors the ergonomics the old context provided.
      activeTweet: state.expandedConversation?.anchorTweet ?? null,
      openConversation: state.openConversation,
      closeConversation: state.closeConversation,
      prefetchConversation: state.prefetchConversation,
    }),
    shallow
  );
}
